import type { CheckboxConfig } from '#types/config/components/vf/checkbox'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      size: {
        md: 'mt-0.5',
        sm: ''
      },
      variant: {
        base: {
          default: 'ring-brand-1',
          selected: 'bg-brand-1 ring-brand-1 c-brand-2'
        },
        inverse: {
          default: 'ring-brand-2',
          selected: 'bg-brand-2 ring-brand-2 c-brand-1'
        }
      }
    },
    label: {
      size: {
        md: 'body-3',
        sm: 'body-4 mt-px'
      },
      variant: {
        base: {
          default: 'c-brand-1'
        },
        inverse: {
          default: 'c-brand-2'
        }
      }
    },
    wrapper: {
      size: {
        md: 'gap-x-2'
      }
    }
  },
  iconSize: {
    sm: 'sm',
    md: 'sm'
  },
  radius: {
    sm: '0.0625rem',
    md: '0.0625rem'
  }
} satisfies RecursivePartial<CheckboxConfig>
